import React, { Component } from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import axios from 'axios'
import Helmet from 'react-helmet'
import MediaQuery from 'react-responsive'
import icon32 from '../images/favicon.png'
import { backendURL } from '../data/config.json'

//Components
import MainForm from '../components/MainForm/'

//Scroll animation
import ScrollAnim from 'rc-scroll-anim'
const ScrollParallax = ScrollAnim.Parallax

class FrontpageEs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      mainImage: {
        title: '',
        url: '',
      },
    }
    this.renderBannersSecondSection = this.renderBannersSecondSection.bind(this)
    this.renderBannersThirdSection = this.renderBannersThirdSection.bind(this)
  }
  componentDidMount() {
    axios
      .get(`${backendURL}/api/banners/page/Home`)
      .then(res => {
        const main = res.data.filter(data => data.section === 'Main')

        console.log(res.data)

        this.setState({
          loading: false,
          banners: res.data,
          mainImage: {
            title: main[0].title.es,
            url: main[0].imageEs,
          },
        })
      })

      .catch(err => {
        console.log(err)
      })
  }

  renderBannersSecondSection() {
    const { banners } = this.state
    return _.map(banners, (banner, i) => {
      const { title, imageEs, published, section, link } = banner
      const { langKey: lang } = this.props.pathContext
      if (published && section === 'Second-Section') {
        if (link) {
          return (
            <div key={i}>
              <a href={link.es}>
                <img src={`${backendURL}${imageEs}`} alt={title[lang]} />
              </a>
            </div>
          )
        } else {
          return (
            <div key={i}>
              <img src={`${backendURL}${imageEs}`} alt={title[lang]} />
            </div>
          )
        }
        return null
      }
    })
  }


  renderBannersThirdSection() {
    const { banners } = this.state
    return _.map(banners, (banner, i) => {
      const { title, imageEs, published, section, link } = banner
      const { langKey: lang } = this.props.pathContext
      if (published && section === 'Third-Section') {
        if (link) {
          return (
            <div key={i}>
              <a href={link.es}>
                <img src={`${backendURL}${imageEs}`} alt={title[lang]} />
              </a>
            </div>
          )
        } else {
          return (
            <div key={i}>
              <img src={`${backendURL}${imageEs}`} alt={title[lang]} />
            </div>
          )
        }

        return null
      }
    })
  }


  renderBannersMeet() {
    const { banners } = this.state
    return _.map(banners, (banner, i) => {
      const { title, imageEs, published, section } = banner
      const { langKey: lang } = this.props.pathContext
      if (published && section === 'Meet') {  
          return (
                <img src={`${backendURL}${imageEs}`} alt={title[lang]} />    
          )
        return null
      }
    })
  }


  render() {
    const { langKey: lang } = this.props.pathContext
    if (this.state.loading) {
      return null
    }
    return (
      <div className="page frontpage">
        <Helmet
          title={`Budget Nicaragua, la mejor opción para alquiler de autos y camiones`}
          meta={[
            {
              name: 'description',
              content:
                'Preguntas frecuentes sobre el alquiler de autos.',
            },

            { name: 'twitter:site', content: '#budgetNicaragua' },
            {
              name: 'twitter:descriptions',
              content:
                'Preguntas frecuentes sobre el alquiler de autos.',
            },
            {
              name: 'twitter:title',
              content:
                'Budget Nicaragua, la mejor opción para alquiler de autos y camiones',
            },
            { name: 'twitter:creator', content: '#budgetNicaragua' },

            {
              property: 'og:title',
              content:
                'Budget Nicaragua, la mejor opción para alquiler de autos y camiones',
            },
            {
              property: 'og:site_name',
              content: 'https://www.facebook.com/budgetNicaragua',
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:url',
              content: 'https://www.facebook.com/budgetNicaragua',
            },
            {
              property: 'og:description',
              content:
                'Preguntas frecuentes sobre el alquiler de autos.',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'es',
              href: './en/index',
            },
            { rel: 'shortcut icon', type: 'image/png', href: `${icon32}` },
          ]}
        />
        <MainForm image={this.state.mainImage} lang={lang} />
        <div style={{background: '#F78621' , height: '55px', margin:'-30px 0 0 0', color:'#fff' ,padding:' 1% 0% 1% 0%', textAlign: 'center'}}>
          <p>
          Pague ahora y ahorre hasta 35% y obtenga nuestras mejores tarifas garantizadas
          </p>
        </div>
        <div className="block-first">
          <div className="grid-wrapper">
            <div className="excerpt">
              <h2>Conozca nuestra Flota ></h2>
              <p>
                Desde lujosos 4x4 hasta vehículos económicos, tenemos el auto
                que necesitas.
              </p>
              <h3>
                <Link to="/es/fleet">Mira nuestra selección</Link>
              </h3>
            </div>
            <MediaQuery query="(min-width: 780px)">
              <ScrollParallax
                animation={{ x: 0, opacity: 1 }}
                style={{
                  transform: 'translateX(100px)',
                  opacity: 0,
                }}
              >
                 {this.renderBannersMeet()}
              </ScrollParallax>
            </MediaQuery>
            <MediaQuery query="(max-width: 780px)">
              <div>
              {this.renderBannersMeet()}
              </div>
            </MediaQuery>
          </div>
        </div>
        {/* Second Section */}
        <MediaQuery query="(max-width: 780px)">
          <div className="block-second">
            <h2 style={{marginLeft :'85px', color: '#fff', fontWeight:'bold'}}>Ofertas Especialessss</h2>    
            <div className="grid-wrapper">
              {this.renderBannersSecondSection()}
            </div>
          </div>
        </MediaQuery>
        <MediaQuery query="(min-width: 780px)">
          <ScrollParallax animation={{ skewY: -15 }}>
            <div className="block-second">
            <h2 style={{marginLeft :'85px', color: '#fff', fontWeight:'bold'}} >Ofertas Especiales</h2> 
              <ScrollParallax animation={{ skewY: 15 }}>
                
                <div className="grid-wrapper">        
                  {this.renderBannersSecondSection()}
                  
                   </div>
              </ScrollParallax>
            </div>
          </ScrollParallax>
        </MediaQuery>
        {/* Third Section */}
        <MediaQuery query="(max-width: 780px)">
          <div className="third-block">
            <div className="grid-wrapper">
              {this.renderBannersThirdSection()}
            </div>
          </div>
        </MediaQuery>
        <div className="third-block">
          <div className="grid-wrapper">{this.renderBannersThirdSection()}</div>
        </div>
      </div>
    )
  }
}

export const query = graphql`
  query FrontpageEsQuery {
    mainImg: imageSharp(id: { regex: "/frontpage-main/" }) {
      sizes(maxWidth: 1600) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`

export default FrontpageEs



// WEBPACK FOOTER //
// ./src/pages/index.es.js